import React, { useEffect, useState } from 'react';
import api from '../api/axios';

const Analytics = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const bizId = JSON.parse(localStorage.getItem('vflow_business') || '{}')?.id;

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = { business_id: bizId };
      if (from && to) { params.from_date = from; params.to_date = to; }
      const r = await api.get('/messages/analytics', { params });
      setData(r.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { fetchData(); const interval = setInterval(fetchData, 30000); return () => clearInterval(interval); }, []);

  const s = data?.summary || {};
  const outbound = Number(s.outbound) || 0;
  const safeOut  = outbound || 1;

  const openRate   = outbound ? ((Number(s.read_count) / outbound) * 100).toFixed(1) : '0.0';
  const respRate   = outbound ? ((Number(s.inbound)    / outbound) * 100).toFixed(1) : '0.0';
  const avgSecs    = data?.avg_response_seconds || 0;
  const avgDisplay = avgSecs === 0
    ? '0 min'
    : avgSecs < 60
      ? `${avgSecs} sec`
      : avgSecs < 3600
        ? `${Math.round(avgSecs / 60)} min`
        : `${(avgSecs / 3600).toFixed(1)} hr`;

  const daily  = [...(data?.daily || [])].reverse();
  const maxVal = Math.max(...daily.map(d => Math.max(Number(d.outbound), Number(d.inbound))), 1);

  return (
    <div style={{ padding: '24px', maxWidth: '100%', fontFamily: 'inherit' }}>

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 500 }}>Analytics</h2>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <input type="date" value={from} onChange={e => setFrom(e.target.value)}
            style={{ padding: '6px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13 }} />
          <span style={{ color: '#888' }}>to</span>
          <input type="date" value={to} onChange={e => setTo(e.target.value)}
            style={{ padding: '6px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13 }} />
          <button onClick={fetchData}
            style={{ padding: '6px 16px', background: '#6C3CE1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
            Apply
          </button>
        </div>
      </div>

      {loading ? <p style={{ color: '#888' }}>Loading...</p> : (
        <>
          {/* ── 3 Metric cards - exact mockup style ── */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 20 }}>
            <div style={{ background: '#f5f3ee', borderRadius: 14, padding: '20px 24px' }}>
              <div style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>Open rate</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#6C3CE1' }}>{openRate}%</div>
              <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>Read / Outbound</div>
            </div>
            <div style={{ background: '#f5f3ee', borderRadius: 14, padding: '20px 24px' }}>
              <div style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>Click rate</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#25b87e' }}>{respRate}%</div>
              <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>Inbound / Outbound</div>
            </div>
            <div style={{ background: '#f5f3ee', borderRadius: 14, padding: '20px 24px' }}>
              <div style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>Avg response time</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#e07b2a' }}>{avgDisplay}</div>
              <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>Inbound → Reply</div>
            </div>
          </div>

          {/* ── Messages by type + Inbound vs Outbound ── */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 20 }}>
              <p style={{ fontSize: 13, fontWeight: 600, margin: '0 0 16px', color: '#333' }}>Messages by type</p>
              {(data?.byType || []).length === 0 && <p style={{ fontSize: 12, color: '#aaa' }}>No data</p>}
              {(data?.byType || []).slice(0, 6).map(t => {
                const pct = Math.round((t.count / safeOut) * 100);
                return (
                  <div key={t.msg_type} style={{ marginBottom: 10 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
                      <span style={{ color: '#555', textTransform: 'capitalize' }}>{t.msg_type || 'text'}</span>
                      <span style={{ color: '#888' }}>{Number(t.count).toLocaleString()}</span>
                    </div>
                    <div style={{ background: '#f0f0f0', borderRadius: 4, height: 7 }}>
                      <div style={{ background: '#6C3CE1', borderRadius: 4, height: 7, width: `${pct}%`, transition: 'width 0.5s' }} />
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 20 }}>
              <p style={{ fontSize: 13, fontWeight: 600, margin: '0 0 16px', color: '#333' }}>Inbound vs Outbound</p>
              {[
                { label: 'Outbound',       value: s.outbound || 0, color: '#6C3CE1' },
                { label: 'Inbound',        value: s.inbound  || 0, color: '#25D366' },
                { label: 'Sent (pending)', value: s.sent     || 0, color: '#FFA726' },
              ].map(r => {
                const total2 = Number(s.total) || 1;
                const pct = Math.round((Number(r.value) / total2) * 100);
                return (
                  <div key={r.label} style={{ marginBottom: 14 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
                      <span style={{ color: '#555' }}>{r.label}</span>
                      <span style={{ color: r.color, fontWeight: 600 }}>{Number(r.value).toLocaleString()}</span>
                    </div>
                    <div style={{ background: '#f0f0f0', borderRadius: 4, height: 7 }}>
                      <div style={{ background: r.color, borderRadius: 4, height: 7, width: `${pct}%`, transition: 'width 0.5s' }} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* ── Daily trend chart ── */}
          <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 20 }}>
            <p style={{ fontSize: 13, fontWeight: 600, margin: '0 0 16px', color: '#333' }}>Daily trend (last 7 days)</p>
            {daily.length === 0
              ? <p style={{ fontSize: 12, color: '#aaa' }}>No data for this period</p>
              : (
                <>
                  <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, height: 130 }}>
                    {daily.map((d, i) => (
                      <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', gap: 2, height: 110 }}>
                          <div style={{ width: '100%', background: '#6C3CE1', borderRadius: '3px 3px 0 0', height: `${Math.round((Number(d.outbound) / maxVal) * 100)}%`, minHeight: 2 }} />
                          <div style={{ width: '100%', background: '#25D366', borderRadius: '3px 3px 0 0', height: `${Math.round((Number(d.inbound) / maxVal) * 100)}%`, minHeight: 2 }} />
                        </div>
                        <span style={{ fontSize: 10, color: '#999' }}>
                          {new Date(d.date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', gap: 16, marginTop: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <div style={{ width: 10, height: 10, background: '#6C3CE1', borderRadius: 2 }} />
                      <span style={{ fontSize: 11, color: '#666' }}>Outbound</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <div style={{ width: 10, height: 10, background: '#25D366', borderRadius: 2 }} />
                      <span style={{ fontSize: 11, color: '#666' }}>Inbound</span>
                    </div>
                  </div>
                </>
              )
            }
          </div>
        </>
      )}
    </div>
  );
};

export default Analytics;
